import { assertIsNotNullish } from "@jaybeeuu/is";
const getPublicStack = (error, framesSincePublic) => {
    const { message, name, stack } = error;
    assertIsNotNullish(stack);
    const messageAndName = `${name}: ${message}`;
    const stackIncludesMessage = stack.startsWith(messageAndName);
    const stackWithoutMessage = stackIncludesMessage
        ? stack.replace(messageAndName, "")
        : stack;
    const stackFrames = stackWithoutMessage.trim().split("\n");
    const publicFrames = stackFrames.slice(framesSincePublic);
    const publicStack = publicFrames.join("\n");
    return stackIncludesMessage
        ? `${messageAndName}\n${publicStack}`
        : publicStack;
};
export class Failure extends Error {
    name;
    success = false;
    reason;
    messageOrError;
    constructor(reason, messageOrError, framesSincePublic) {
        super(messageOrError instanceof Error
            ? messageOrError.message
            : String(messageOrError));
        this.messageOrError = messageOrError;
        this.name = `Failure(${reason})`;
        this.reason = reason;
        if (this.stack?.startsWith("Error")) {
            this.stack = this.stack.replace("Error", this.name);
        }
        this.stack =
            messageOrError instanceof Error && messageOrError.stack
                ? messageOrError.stack
                : getPublicStack(this, framesSincePublic);
    }
}
export function success(value) {
    return { success: true, value: value };
}
const failure = (reason, messageOrError, framesSincePublic = 1) => {
    return new Failure(reason, messageOrError ?? "{No message}", framesSincePublic);
};
const repackError = (result, newFailureReason, failureMessagePrefix, framesSincePublic = 1) => {
    return result.success
        ? result
        : failure(newFailureReason, `${failureMessagePrefix}\n${result.reason}: ${result.message}`, framesSincePublic + 1);
};
const exportedFailure = failure;
const exportedRepackError = repackError;
export { exportedFailure as failure, exportedRepackError as repackError };
//# sourceMappingURL=results.js.map